/**
 * Whether a cart requires a card before booking.
 *
 * This lived in two places with two different definitions:
 * `LookupPhoneNumber` used the full predicate to decide the route, while the
 * 428 recovery in `index.tsx` used `hasPayAdvance` alone. A DEPOSIT service
 * carries no `hasPayAdvance`, so the recovery re-flagged it as "no card
 * needed" and dropped the payment method the customer had already entered,
 * ending in a server rejection. One definition, used by both.
 */
export interface PaymentRequirementService {
  hasPayAdvance?: boolean;
  paymentRequirement?: "NONE" | "DEPOSIT" | "FULL";
}

export const servicesRequirePayment = (
  services: PaymentRequirementService[],
): boolean =>
  services.some(
    (service) =>
      Boolean(service.hasPayAdvance) ||
      (Boolean(service.paymentRequirement) &&
        service.paymentRequirement !== "NONE"),
  );
